import Modal from 'antd/lib/modal'
require('antd/lib/modal/style')
import styled from 'styled-components'
import { Colors, media } from '../../Themes'

const types = {
  basic: `${24}px`,
  info: `${24}px ${24}px ${32}px ${24}px`,
  form: `${16}px ${24}px ${24}px ${24}px`
}
const StyledModal = styled(Modal)`
  && {
    ${media.max.mobile`max-width: 100vw;`};
    .ant-modal-header {
      padding: 0;
      border-bottom: none;
    }
    .ant-modal-body {
      padding: ${props => types[props.type] || types['basic']};
      ${media.min.tablet`padding: 24px;`};
    }
    .ant-modal-title {
      padding: 8px 24px;
      line-height: 40px;
      background-color: ${Colors.aliceBlue};
      border-radius: 4px 4px 0 0;
      color: ${Colors.greyishBrown};
      font-size: 18px;
      font-weight: 700;
    }
    .ant-modal-close-x {
      position: relative;
      left: 3px;
      top: 8px;
      line-height: 40px;
      width: 78px;
      color: ${Colors.pinkishGrey};
      &:before {
        font-size: 24px;
      }
    }

    .ant-form-item {
      margin-bottom: 16px;
    }
    .ant-form-item:last-child {
      margin-bottom: 0;
    }
    .ant-modal-footer {
      background-color: ${Colors.aliceBlue};
      padding: 12px 24px;
      height: 56px;
      border-top: none;
    }

    .ant-btn-primary {
      float: right;
    }
  }
`

StyledModal.confirm = Modal.confirm
export default StyledModal
